import { useAppLanguage } from "@/hooks/use-app-language";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { Languages } from "lucide-react";

type LanguageSwitchProps = {
  className?: string;
};

export function LanguageSwitch({ className }: LanguageSwitchProps) {
  const { t, i18n } = useTranslation();
  const language = useAppLanguage();

  return (
    <label
      className={cn(
        "flex items-center justify-center gap-1.5 text-sm text-muted-foreground",
        className,
      )}
    >
      <Languages className="h-4 w-4 shrink-0" aria-hidden />
      <select
        className="cursor-pointer border-0 bg-transparent p-0 text-sm text-muted-foreground shadow-none outline-none focus:ring-0 focus-visible:outline-none"
        value={language}
        aria-label={t("common.language")}
        onChange={(e) => {
          void i18n.changeLanguage(e.target.value);
        }}
      >
        <option value="en">{t("common.english")}</option>
        <option value="de">{t("common.german")}</option>
      </select>
    </label>
  );
}
